import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-home-large",
  templateUrl: "./med-icon-home-large.component.html",
})
export class MedIconHomeLargeComponent extends SvgMixinLargeComponent { }
